<template>
    <section :class="clss">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10">
                    <div v-if="item" class="post wow fadeIn">

                        <figure v-if="item.image" class="post-image"><img :src="'/static/files/'+item.image" alt="">
                        </figure>


                        <div class="post-content">
                            <h4>{{item.title}}</h4>
                            <b>{{item.created_at|nice}}</b>

                            <a v-if="item.file" :href="'/static/files/'+item.file">Download Report</a>
                            <div class="body" v-html="item.body">

                            </div>

                            <div class="share">

                                <ShareNetwork
                                        network="facebook"
                                        :url="url"
                                        :title="item.title"
                                        :description="trim(item.body)"
                                        :quote="item.title"
                                        hashtags="PressRelease"
                                        class="share-link"
                                >

                                    <img  :src="'/static/img/social/facebook.svg'" alt="">
                                    Share on Facebook
                                </ShareNetwork>

                                 <ShareNetwork
                                        network="twitter"
                                        :url="url"
                                        :title="item.title"
                                        :description="trim(item.body)"
                                        :quote="item.title"
                                        hashtags="PressRelease"
                                        class="share-link"
                                >

                                    <img  :src="'/static/img/social/twitter.svg'" alt="">
                                     Share on Twitter
                                </ShareNetwork>

                                 <ShareNetwork
                                        network="linkedin"
                                        :url="url"
                                        :title="item.title"
                                        :description="trim(item.body)"
                                        :quote="item.title"
                                        hashtags="PressRelease"
                                        class="share-link"
                                >
                                    <img  :src="'/static/img/social/linkedin.svg'" alt="">
                                     Share on LinkedIN
                                </ShareNetwork>


                            </div>

                            <div class="social">
                                <h5>Short Link</h5>
                                <input type="text" id="shorturl" :value="'https://shml.link/l/'+item.id"/>
                                <img :src="'/static/img/share.png'" alt="">
                            </div>

                        </div>

                    </div>
                    <!-- end post-content -->
                </div>
                <!-- end post -->

                <!-- end post -->

            </div>
            <!-- end col-10 -->
        </div>
        <!-- end row -->

        <!-- end container -->
    </section>

</template>

<script>

    let dateFns = require("date-fns");
    let trimHtml = require("trim-html");
    export default {
        props: [],
        data: function () {
            return {
                url: window.location.href,
                item: null,
                page: 1,
                itemsPerPage: 9,
                search: {},
              clss : 'blog'
            }
        },
        filters: {
            nice(dt) {
                return dateFns.format(dateFns.fromUnixTime(Date.parse(dt) / 1000), 'dd MMMM, yyyy');
            }
        },
        methods : {
           trim(text) {
             if(text){
               return trimHtml(text, {limit: 300}).html;
             }
             return text;
            }
        },
        mounted() {
            this.item = __article__;
            for (const tag of this.item.tags){
              if (tag.title == 'arabic') {
                this.clss = 'blog arabic'
              }
            }
        },


    }

</script>

<style lang="scss">

    $color-blue: #490eea;
    $color-turquaz: #7ee6f8;
    $color-dark: #131314;

    /* BLOG */

    .blog {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: 0;
        margin-top: 139px;

        p {
            line-height: 1.9;
        }

      &.arabic {
        text-align: right;
        direction: rtl
      }

      .share {
        margin-top: 30px;
      }
        .share-link {

            padding: 8px 12px;
            transition: all 0.3s ease;
            background: #f0f0f0;
            color: #222;
            cursor: pointer;
            margin: 0 4px;

            img {
                width: 24px;
                transition: all 0.3s ease;
            }



        }

        .share-link:hover {
             text-decoration: none;
                img {
                    transform: scale(1.12);
                }

            }





        .post {
            width: 100%;
            display: block;
            float: left;
            margin: 50px 0;
            background: #fff;
            box-shadow: 0 0 40px rgba(0, 0, 0, 0.05);

            &.single .post-content {
                padding: 60px;
            }

            .post-image {
                width: 100%;
                display: block;
                margin-bottom: 0;

                img {
                    width: 100%;
                    max-height: 500px;
                    object-fit: cover;
                }
            }

            .post-content {
                width: 100%;
                display: block;
                padding: 30px;

                .author {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    margin: 0;

                    img {
                        height: 60px;
                        float: left;
                        margin-right: 15px;
                        border-radius: 50%;
                    }

                    figcaption {
                        display: inline-block;

                        h6 {
                            font-weight: 600;
                            margin-top: 10px;
                            margin-bottom: 0;
                        }

                        small {
                            font-weight: 300;
                            opacity: 0.6;
                        }
                    }
                }

                .post-categories {
                    width: 100%;
                    display: flex;
                    flex-wrap: wrap;
                    margin: 30px 0;
                    padding: 0;
                    padding-top: 30px;
                    border-top: 1px solid #eee;

                    li {
                        display: inline-block;
                        list-style: none;
                        margin-right: 5px;

                        a {
                            font-weight: 600;
                            font-size: 11px;
                            background: $color-dark;
                            color: #fff;
                            line-height: 1;
                            padding: 3px 6px;

                            &:hover {
                                background: $color-blue;
                                text-decoration: none;
                            }
                        }
                    }
                }

                .social {
                    display: flex;
                    align-items: center;
                    justify-items: center;

                    margin-top: 50px;

                    h5 {
                        min-width: 100px;
                        margin: 0;
                    }

                    input {
                        min-width: 280px;
                        background: #fffce8fc;
                    }

                    img {
                        width: 32px;
                        height: 32px;
                    }
                }

                .social-share {
                    width: 100%;
                    float: left;
                    padding: 0;
                    margin-bottom: 40px;
                    text-align: center;

                    li {
                        float: left;
                        margin-right: 5px;
                        padding: 0;
                        list-style: none;

                        &.facebook a {
                            background: #475993;
                        }

                        &.twitter a {
                            background: #76a9ea;
                        }

                        &.google-plus a {
                            background: #f34a38;
                        }

                        &.linkedin a {
                            background: #0077b7;
                        }

                        &.youtube a {
                            background: #f61c0d;
                        }

                        a {
                            width: 44px;
                            height: 44px;
                            line-height: 44px;
                            float: left;
                            background: $color-dark;
                            color: #fff;
                            border: none;
                            border-radius: 0;
                        }
                    }
                }

                .image-left {
                    width: 40%;
                    float: left;
                    margin-right: 30px;
                    margin-bottom: 30px;
                    margin-top: 20px;
                }

                .image-full {
                    width: 100%;
                    display: block;
                    margin: 30px 0;
                }

                blockquote {
                    background: $color-turquaz;
                    padding: 30px;
                    font-size: 19px;
                    line-height: 1.6;
                }

                h5 {
                    font-weight: 700;
                    margin-top: 30px;
                }

                ul {
                    margin-bottom: 30px;
                    padding-left: 20px;

                    li {
                        margin: 0;
                    }
                }

                b {
                    width: 100%;
                    display: block;
                    margin-bottom: 10px;
                    text-transform: uppercase;
                    font-size: 14px;
                }

                h4 {
                    display: block;
                    font-size: 3vw;
                    line-height: 1.2;
                    margin-bottom: 20px;

                    a {
                        color: $color-dark;

                        &:hover {
                            color: $color-blue;
                            text-decoration: none;
                        }
                    }
                }
            }
        }

        .sidebar {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            padding-left: 80px;
            margin: 50px 0;

            .widget {
                width: 100%;
                display: block;
                margin-bottom: 50px;
                background: #fff;
                box-shadow: 0 0 40px rgba(0, 0, 0, 0.05);
                padding: 40px;
                padding-top: 0;

                .categories {
                    width: 100%;
                    display: block;
                    margin: 0;
                    padding: 0;

                    li {
                        width: 100%;
                        display: block;
                        margin: 0;
                        padding: 3px 0;
                        list-style: none;

                        a {
                            margin: 0;

                            &:hover {
                                color: $color-blue;
                                text-decoration: none;
                            }
                        }

                        span {
                            float: right;
                            opacity: 0.5;
                        }
                    }
                }

                .tags {
                    width: 100%;
                    display: block;
                    margin: 0;
                    padding: 0;

                    li {
                        display: inline-block;
                        margin-right: 5px;
                        margin-bottom: 5px;
                        padding: 0;
                        list-style: none;

                        a {
                            color: #fff;
                            background: $color-blue;
                            display: inline-block;
                            font-size: 13px;
                            padding: 3px 6px;

                            &:hover {
                                color: $color-blue;
                                background: $color-turquaz;
                                text-decoration: none;
                            }
                        }
                    }
                }

                .side-gallery {
                    display: block;
                    margin-left: -1px;
                    margin-right: -1px;
                    padding: 0;

                    li {
                        width: 50%;
                        float: left;
                        margin: 0;
                        padding: 1px;
                        list-style: none;
                    }
                }

                p {
                    margin-bottom: 0;

                }

                form {
                    margin: 0;

                    input[type="search"] {
                        width: 100%;
                        margin-bottom: 10px;
                    }
                }

                .title {
                    width: 100%;
                    border-bottom: 2px solid #eee;
                    line-height: 1;
                    font-size: 18px;
                    font-weight: 700;
                    text-transform: uppercase;
                    padding: 30px 0;
                    margin-bottom: 30px;
                    color: $color-blue;
                    position: relative;

                    &:before {
                        content: "";
                        width: 60px;
                        height: 2px;
                        background: $color-turquaz;
                        position: absolute;
                        left: -40px;
                        bottom: -2px;
                    }
                }
            }
        }

        .pagination {
            margin: 50px 0;
        }
    }

    /* PAGINATION */
    .pagination {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        float: left;
        margin-top: 40px;
        margin-bottom: 0;

        .page-item {
            display: inline-block;

            &.active .page-link {
                background: $color-blue;
                color: #fff;
            }

            .page-link {
                border-color: #eee;
                border-radius: 0 !important;
                font-size: 13px;
                font-weight: 700;
                color: $color-dark;
                padding: 15px 20px;

                span {
                    display: inline-block;
                    font-size: 20px;
                    margin: 0 5px;
                }

                &:hover {
                    background: $color-blue;
                    color: #fff;
                }
            }
        }
    }


</style>